import React from "react";
import { object, string } from "prop-types";

import SectionMenuDom from "./SectionMenuDom";
import ChildSectionDom from "./ChildSectionsDom";

import "./menuItems.m.css";

const MenuItems = ({
  sectionMenuItem,
  domainSectionObj,
  domainSlug,
  language,
  sectionsDataForHeader,
  multiDomainWrapperName,
  collection,
  pageType,
}) => (
  <div styleName="menu-items" className="header-menu-items">
    {" "}
    {sectionMenuItem ? (
      <SectionMenuDom
        domainSectionObj={domainSectionObj}
        domainSlug={domainSlug}
        language={language}
        sectionsDataForHeader={sectionsDataForHeader}
        sectionMenuItem={sectionMenuItem}
        multiDomainWrapperName={multiDomainWrapperName}
      />
    ) : (
      <ChildSectionDom
        domainSectionObj={domainSectionObj}
        domainSlug={domainSlug}
        language={language}
        collection={collection}
        pageType={pageType}
        sectionsDataForHeader={sectionsDataForHeader}
        multiDomainWrapperName={multiDomainWrapperName}
      />
    )}
  </div>
);

MenuItems.propTypes = {
  sectionMenuItem: object,
  domainSectionObj: object,
  domainSlug: string,
  language: string,
  sectionsDataForHeader: object,
  multiDomainWrapperName: string,
  collection: object,
  pageType: string,
};

export default MenuItems;
